import type { DataSource } from '@lmt/unicorn-shared/app/common/devexpress/dx-data-source';

export function isAnyObjectInDataSourceSuitFilter(
  dataSource: DataSource,
  filter: any,
): boolean {
  if (!filter) {
    // if filter is not defined - it suits all events
    return true;
  }
  dataSource.filter(filter);

  let result = false;
  dataSource.load().then((x) => {
    result = (x as []).length > 0;
  });
  return result;
}
